<main class="auth-shell">
  <span class="glow glow-top"></span>
  <span class="glow glow-bottom"></span>
  <span class="grid-pattern"></span>

  <div class="auth-layout">
    <section class="product-story">
      <div class="story-brand">
        <img class="story-wordmark" src="/passbook-logo.png" alt="Passbook" />
      </div>

      <div class="story-copy">
        <span class="story-kicker">Built for jewellery retailers</span>
        <h1>Digitize your gold savings plans.</h1>
        <p>
          Manage 10+1, Gold Rate Protection, and Lumpsum Plans with
          simple digital tools your team and customers will love.
        </p>

        <div class="feature-list">
          <div class="feature-item">
            <mat-icon>qr_code_2</mat-icon>
            <div>
              <strong>QR Enrollment</strong>
              <span>Onboard customers with a simple scan</span>
            </div>
          </div>
          <div class="feature-item">
            <mat-icon>chat_bubble_outline</mat-icon>
            <div>
              <strong>WhatsApp Automation</strong>
              <span>Send receipts and reminders instantly</span>
            </div>
          </div>
          <div class="feature-item">
            <mat-icon>insights</mat-icon>
            <div>
              <strong>Real-time Dashboard</strong>
              <span>Track renewals and every branch in one place</span>
            </div>
          </div>
        </div>
      </div>

      <p class="story-footer">
        <mat-icon>verified</mat-icon>
        No setup fee · Get started in 24 hours
      </p>
    </section>

    <section class="auth-card">
      <div class="login-content">
        <div class="intro">
          <span class="intro-tag">Secure access</span>
          <h1>{{ otpSent() ? 'Verify your OTP' : 'Welcome to Passbook' }}</h1>
          @if (otpSent()) {
            <p>
              Enter the 6-digit code sent to <strong>{{ submittedIdentifier() }}</strong>.
              <button class="text-button" type="button" (click)="editIdentifier()">Change</button>
            </p>
          } @else {
            <p>Sign in with your mobile number or email address.</p>
          }
        </div>

        @if (!otpSent()) {
          <form [formGroup]="loginForm" (ngSubmit)="onSendOtp()" autocomplete="on" novalidate>
            <div class="field-group">
              <label for="identifier">Mobile / Email</label>
              <div
                class="field-control"
                [class.invalid]="loginForm.controls.identifier.touched && loginForm.controls.identifier.invalid"
              >
                <mat-icon>person_outline</mat-icon>
                <input
                  id="identifier"
                  type="text"
                  formControlName="identifier"
                  name="passbook-identifier"
                  autocomplete="username"
                  autocapitalize="off"
                  autocorrect="off"
                  spellcheck="false"
                  placeholder="Enter mobile number or email"
                />
              </div>
              @if (loginForm.controls.identifier.touched && loginForm.controls.identifier.hasError('required')) {
                <p class="field-error">Mobile number or email is required</p>
              } @else if (loginForm.controls.identifier.touched && loginForm.controls.identifier.hasError('mobileOrEmail')) {
                <p class="field-error">Enter a valid 10-digit mobile number or email</p>
              }
            </div>

            @if (errorMessage()) {
              <div class="error-banner" role="alert">
                <mat-icon>error_outline</mat-icon>
                <p>{{ errorMessage() }}</p>
              </div>
            }

            <button class="primary-button" type="submit" [disabled]="!canSubmit()">
              <span>{{ isSubmitting() ? 'Sending OTP…' : 'Send OTP' }}</span>
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </form>
        } @else {
          <form [formGroup]="otpForm" (ngSubmit)="onVerifyOtp()" autocomplete="on" novalidate>
            <div class="field-group">
              <label>One-time password</label>
              <div class="otp-boxes" formArrayName="otp" role="group" aria-label="One-time password">
                @for (control of loginOtpControls.controls; track $index) {
                  <input
                    class="otp-box"
                    [class.invalid]="control.touched && control.invalid"
                    [id]="'login-otp-' + $index"
                    type="text"
                    inputmode="numeric"
                    maxlength="1"
                    [formControlName]="$index"
                    autocomplete="one-time-code"
                    [attr.aria-label]="'OTP digit ' + ($index + 1)"
                    (input)="onOtpInput($index, $event)"
                    (keydown)="onOtpKeydown($index, $event)"
                    (paste)="onOtpPaste($event)"
                  />
                }
              </div>
              @if (otpForm.controls.otp.touched && otpForm.controls.otp.invalid) {
                <p class="field-error">Enter the 6-digit OTP</p>
              }
            </div>

            <div class="otp-actions">
              @if (loginOtpCountdown() > 0) {
                <span class="otp-countdown">
                  Resend OTP in {{ formatOtpCountdown(loginOtpCountdown()) }}
                </span>
              } @else {
                <button class="text-button" type="button" (click)="resendOtp()">Resend OTP</button>
              }
            </div>

            @if (errorMessage()) {
              <div class="error-banner" role="alert">
                <mat-icon>error_outline</mat-icon>
                <p>{{ errorMessage() }}</p>
              </div>
            }

            <button class="primary-button" type="submit" [disabled]="!canSubmit()">
              <span>{{ isSubmitting() ? 'Verifying…' : 'Verify OTP' }}</span>
              <mat-icon>verified_user</mat-icon>
            </button>
          </form>
        }

        <div class="access-note">
          <mat-icon>shield</mat-icon>
          <div>
            <strong>Protected administrator access</strong>
            <span>Authorized jewellery retail partners only</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</main>
